<template>
  <div v-if="info.content || info.title" class="contract-fill-item">
    <div class="contract-sub-title">{{ info.title }}</div>
    <div v-if="info.dateType !== 2" class="input fill-input">
      {{ signingData || "&nbsp;" }}
    </div>
    <el-date-picker
      v-else
      v-model="info.content"
      type="date"
      value-format="yyyy-MM-dd"
      clearable
      placeholder="选择日期时间"
      :disabled="isStartGenerate"
    >
    </el-date-picker>
  </div>
</template>
<script>
import { formatDate } from "@/utils/utils";
import message from "@/utils/message";
export default {
  name: "ContractDate",
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    isStartGenerate: {
      type: Boolean,
      default: false,
    },
  },
  created(){
    // alert(JSON.stringify(this.info))
  },
  computed: {
    signingData({ info }) {
      const currentDate = 0;
      // 当前日期
      if (info.dateType === currentDate) {
        return formatDate(new Date());
      } else {
        return info.content;
      }
    },
  },
  methods: {
    getSubmitData() {
      if (this.info.dateType === 2) {
        const { title, isRequire, content, subjectType } = this.info;
        if (!isRequire) {
          return {
            questionnaire: 1,
            options: content,
            isRequired: isRequire ? 1 : 0,
            content: title,
            type: subjectType,
          };
        }
        if (!content) {
          message(`${title}未填写`);
          return false;
        }
        return {
          questionnaire: 1,
          options: content,
          isRequired: isRequire ? 1 : 0,
          content: title,
          type: subjectType,
        };
      } else {
        return {
          writeDate: this.signingData,
        };
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.contract-fill-item {
  margin-top: 30px;

  .fill-input {
    margin-top: 10px;
    border-radius: 4px;
    width: 90%;
    font-size: 16px;
    padding: 4px 0;
    border: 1px solid #eee;
    padding-left: 10px;
  }
}

.contract-sub-title {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: bold;
}
</style>
